import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { Router, ActivatedRoute } from '@angular/router';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, Keys } from 'lib/common';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgSwitchCase, DOCUMENT } from '@angular/common';
import { validateBasis } from '@angular/flex-layout';
import { SystemSettingsService } from 'src/app/shared/services/system-settings/system-settings.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  rsltType: string = "logout";

  title: string = "Logout";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  constructor(private logservice: SystemSettingsService, private router: Router, private route: ActivatedRoute) {
   
  }

  ngOnInit() {
    setTimeout(() => {
      this.logservice.logDetail = "";
      this.logservice.LogType = "";
      this.logservice.CompanyLogo = "";
      this.logservice.UserName = "";
      this.logservice.isLoggedIn = false;
      this.logservice.isCommonLogo = true;

      if (localStorage.getItem('SystemSettings') != null) {
        localStorage.removeItem('SystemSettings');
        localStorage.clear();
      }

      if (sessionStorage.getItem('SystemSettings') != null) {
        sessionStorage.removeItem('SystemSettings');
        sessionStorage.clear();
      }

      if (localStorage.getItem('Keyword') != null) {
        localStorage.removeItem('Keyword');
        localStorage.clear();
      }

      if (sessionStorage.getItem('Keyword') != null) {
        sessionStorage.removeItem('Keyword');
        sessionStorage.clear();
      }

      this.parentEvent();
    });

    //console.log('redirect to login out')
    this.router.navigateByUrl('/login?logout=true');
  }

  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }
}
